import React, { StrictMode } from 'react';
import PropTypes from 'prop-types';

import { ContextProvider } from './Context';
import Header from './Views/Header/Index';
import CpaDetails from './Views/CpaDetails/Index';
import Utilization from './Views/Utilization/Index';
import MemberFeedback from './Views/MemberFeedback/Index';

export default function Index({ policyEnabled }) {
  return (
    <StrictMode>
      <ContextProvider>
        <div className="content">
          <Header policyEnabled={policyEnabled} />
        </div>

        <div className="content">
          <section>
            <CpaDetails />
            <Utilization />
          </section>
        </div>

        <div className="content">
          <MemberFeedback />
        </div>
      </ContextProvider>
    </StrictMode>
  );
}

Index.propTypes = {
  policyEnabled: PropTypes.bool,
};

Index.defaultProps = {
  policyEnabled: true,
};
